@if (isOpen) {
  <div class="popover {{ position }}" #popoverContent>
    @if (title) {
      <div class="popover-title pb-1 font-weight-bold">{{ title }}</div>
    }
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
}